
import { namespace } from 'vuex-class';
import { Component, Prop, Emit, Mixins, Watch } from 'vue-property-decorator';

import { OfferPresentationType } from '@/interfaces/titles';
import type { TitleDetail, TitleDetailSeason } from '@/interfaces/title-details-graphql';

import TitleWatchlistMutationMixin from '@/mixins/title-quick-action-mutations/TitleWatchlistMutationMixin.vue';
import NoOfferBell from '@/components/buybox/NoOfferBell.vue';

const Language = namespace('language');
const User = namespace('user');

@Component({
	name: 'BuyBoxNoOfferRow',
	components: { NoOfferBell },
})
export default class BuyBoxNoOfferRow extends Mixins(TitleWatchlistMutationMixin) {
	@Prop({ required: true }) title: TitleDetail | TitleDetailSeason;

	@Prop({ default: false }) isTitleInWatchlist: boolean;

	@Prop({ required: true }) titleHasNoOffers: boolean;
	@Prop({ default: false }) inline: boolean;

	@Language.Getter isTTBLanguage: string;

	@User.Getter buyboxPresentationType: OfferPresentationType;

	/** Filtering for free offers but this title does have other offers */
	get displayNoFreeOffers() {
		return this.buyboxPresentationType === OfferPresentationType.FREE && !this.titleHasNoOffers;
	}

	get noFreeOfferCTA() {
		return this.isTitleInWatchlist
			? this.$tc('WEBAPP_WATCHLIST_FREE_ALREADY_ADDED')
			: this.$tc('WEBAPP_WATCHLIST_FREE_CTA');
	}

	get id() {
		return this.title.__typename === 'Season' ? this.title.show.id : this.title.id;
	}

	get titleDetails() {
		const title = this.title.__typename === 'Season' ? this.title.show : this.title;

		return {
			title: title.content.title,
			objectType: title.objectType,
			objectId: title.objectId,
		};
	}

	async onNotifyMe() {
		const updatedTitle = await this.mixin_setInWatchlist(this.id, this.isTitleInWatchlist, this.titleDetails, {
			source: 'buybox',
		});

		if (updatedTitle) {
			this.onWatchlistToggle(updatedTitle.data?.setInWatchlistV2.title.watchlistEntryV2?.createdAt);
		}
	}

	@Watch('isLoggedIn', { immediate: true })
	onIsLoggedInChange(isLoggedIn: boolean) {
		if (!isLoggedIn) return;

		this.mixin_onIsLoggedInChange(this.id, this.titleDetails, this.isTitleInWatchlist, 'buybox');
	}

	@Emit('onWatchlistToggle')
	onWatchlistToggle(createdAt: string | null) {
		return createdAt;
	}
}
